import { root } from './seed.js';
import { filesystemState, getFsMap } from './store.svelte.js';
import { virtualSearchNodes } from './search.js';

export function getNode(path) { return getFsMap().get(path) || null; }

function canOpenAsFolder(node) { return Boolean(node && node.children); }

export function createFinderState(saved = {}) {
  const currentPath = getNode(saved.currentPath) ? saved.currentPath : '/Users/Guest';
  const history = Array.isArray(saved.history) && saved.history.length
    ? saved.history.filter((path) => getNode(path))
    : [currentPath];
  return {
    currentPath,
    history: history.length ? history : [currentPath],
    historyIdx: Math.max(0, Math.min(saved.historyIdx ?? history.length - 1, Math.max(history.length - 1, 0))),
  };
}

export function cd(state, path) {
  const node = getNode(path);
  if (!canOpenAsFolder(node)) return;
  if (state.currentPath === path) return;
  state.currentPath = path;
  const next = state.history.slice(0, state.historyIdx + 1);
  next.push(path);
  state.history = next;
  state.historyIdx = next.length - 1;
}

export function cdUp(state) {
  if (state.currentPath.startsWith('search://')) return;
  const parts = state.currentPath.split('/').filter(Boolean);
  if (!parts.length) return;
  parts.pop();
  cd(state, parts.length ? `/${parts.join('/')}` : '/');
}

export function goBack(state) {
  if (state.historyIdx > 0) { state.historyIdx -= 1; state.currentPath = state.history[state.historyIdx]; }
}

export function goForward(state) {
  if (state.historyIdx < state.history.length - 1) { state.historyIdx += 1; state.currentPath = state.history[state.historyIdx]; }
}

export const canGoBack = (state) => state.historyIdx > 0;
export const canGoForward = (state) => state.historyIdx < state.history.length - 1;

export function getPathCrumbs(path = '/Users/Guest') {
  if (path.startsWith('search://')) {
    const node = getNode(path);
    return [{ name: 'Search For', path: null }, { name: node?.name ?? path.replace('search://', ''), path }];
  }
  const parts = path.split('/').filter(Boolean);
  const crumbs = [{ name: root.name, path: '/' }];
  let cursor = '';
  for (const part of parts) { cursor += `/${part}`; crumbs.push({ name: part, path: cursor }); }
  return crumbs;
}

export function getColumnChain(path = '/Users/Guest') {
  if (path.startsWith('search://')) return [getNode(path)].filter(Boolean);
  return getPathCrumbs(path).map((crumb) => getNode(crumb.path)).filter(Boolean);
}

export function kindLabel(node) {
  if (!node) return '';
  if (node.kind === 'app') return 'Application';
  if (node.kind === 'file') {
    if (node.name.endsWith('.pdf')) return 'PDF document';
    if (node.name.endsWith('.rtf')) return 'Rich Text document';
    if (node.name.endsWith('.plist')) return 'Property list';
    if (node.name.endsWith('.webloc')) return 'Internet location';
    if (node.name.endsWith('.zip')) return 'ZIP archive';
    if (node.name.endsWith('.dmg')) return 'Disk image';
    if (node.icon === 'image-file') return 'PNG/JPEG image';
    if (node.icon === 'movie-file') return 'QuickTime movie';
    if (node.icon === 'audio-file') return 'Audio file';
    return 'Document';
  }
  if (node.path === '/') return 'Startup disk';
  if (node.path.startsWith('/Volumes/')) return 'Volume';
  if (node.path.startsWith('/Network/')) return 'Network computer';
  if (node.path.startsWith('search://')) return 'Saved search';
  return 'Folder';
}

export const smartSources = {
  get devices() { filesystemState.revision; return [getNode('/'), getNode('/Volumes/iDisk'), getNode('/Volumes/Cruzer')].filter(Boolean); },
  get shared() { filesystemState.revision; return [getNode('/Network/Richard XXI')].filter(Boolean); },
  get places() { filesystemState.revision; return [getNode('/Users/Guest/Desktop'), getNode('/Users/Guest'), getNode('/Applications'), getNode('/Users/Guest/Downloads'), getNode('/Users/Guest/Documents'), getNode('/Users/Guest/Projects'), getNode('/Users/Guest/Pictures')].filter(Boolean); },
  get searchFor() { filesystemState.revision; return virtualSearchNodes; },
};
